export const tagColors = [
  "#DDE3F3",
  "#DDF3DD",
  "#E8DDF3",
  "#7DEAEA36",
  "#F3DDDD",
  "#F0F3DD",
];
